export enum AuthEventType {
  SignInWithRedirect = 'signInWithRedirect',
  SignInWithRedirectFailure = 'signInWithRedirect_failure',
  TokenRefreshFailure = 'tokenRefresh_failure',
  SignOut = 'signOut',
  CustomOAuthState = 'customOAuthState',
}

export type AuthHubError = {
  message: string;
  underlyingError: string;
};

interface AuthEventDataMap {
  [AuthEventType.SignInWithRedirect]: undefined;
  [AuthEventType.SignInWithRedirectFailure]: { error: AuthHubError };
  [AuthEventType.TokenRefreshFailure]: { error: AuthHubError };
  [AuthEventType.SignOut]: undefined;
  [AuthEventType.CustomOAuthState]: string;
}

type MappedAuthEvent<T extends AuthEventType> = {
  event: T;
  message?: string;
} & (T extends keyof AuthEventDataMap ? { data: AuthEventDataMap[T] } : { data?: never });

export type AuthEvent = { [K in AuthEventType]: MappedAuthEvent<K> }[AuthEventType];

type AuthListener = (event: AuthEvent) => void;

const state: { listeners: AuthListener[] } = {
  listeners: [],
};

const listen = (listener: AuthListener): (() => void) => {
  state.listeners = [...state.listeners, listener];
  return () => {
    state.listeners = state.listeners.filter(l => l !== listener);
  };
};

const dispatch = (payload: AuthEvent): void => {
  [...state.listeners].forEach(listener => {
    try {
      listener(payload);
    } catch (e) {
      console.error('Error in AuthHub listener:', e);
    }
  });
};

export const AuthHub = {
  listen,
  dispatch,
};
